import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ControlProperty, ListRange, SearchCriteriaBase } from '../../../../../../common/models';
import { ClosedPeriodFrequency } from '../constants';
import { ListQueryParam } from '../../../../../../common/constants';
import { LocalDateRangeModel, LocalDateRangeInputModel, LocalDateModel } from '../../../../../models/local-date.model';
import { mustNotBeBlankValidator } from '../../../../../../common/utils';

export class ClosedPeriodModel {
  id?: number;
  frequency: ClosedPeriodFrequency;
  period: LocalDateRangeModel;
  name: string;

  constructor(params?: ClosedPeriodModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class ClosedPeriodForm {
  constructor(
    model: ClosedPeriodModel,
    public id: ControlProperty<number> = model.id,
    public name: ControlProperty<string> = [model.name, [Validators.required, mustNotBeBlankValidator]],
    public period: ControlProperty<LocalDateRangeInputModel> = [
      new LocalDateRangeInputModel(model.period),
      [dateRangeRequiredValidator()],
    ],
    public frequency: ControlProperty<ClosedPeriodFrequency> = [model.frequency, [Validators.required]],
  ) {}
}

export class ClosedPeriodListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Filter]: string;

  constructor(params?: ClosedPeriodListSearchCriteria | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class ClosedPeriodRangeOutputModel {
  start: LocalDateModel;
  end: LocalDateModel;

  constructor(params?: { period?: LocalDateRangeInputModel; closedPeriod?: LocalDateRangeModel; timezone?: string }) {
    if (params) {
      const { period, closedPeriod } = params;
      let { start, end } = period;
      const timezone = params.timezone ?? closedPeriod?.start?.timezone;

      start = new Date(start ?? closedPeriod?.start?.timestamp);
      end = new Date(end ?? closedPeriod?.end?.timestamp);

      this.start = {
        ...closedPeriod?.start,
        ...LocalDateModel.createLocalDateWithCalculatedOffset(start.valueOf(), timezone),
      };

      this.end = {
        ...closedPeriod?.end,
        ...LocalDateModel.createLocalDateWithCalculatedOffset(end.valueOf(), timezone),
      };
    }
  }
}

export function dateRangeRequiredValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as LocalDateRangeInputModel;
    if (!value || !value.start || !value.end) {
      return { required: true };
    }

    return null;
  };
}
